import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: { title: "Login" },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: { title: "Forgot Password" },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/auth/logout/basic.vue"),
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logout").finally(() => {
          localStorage.removeItem("jwt");
          localStorage.removeItem("user");
          next({ name: "login" });
        });
      },
    },
  },

  {
    path: "/",
    name: "home",
    component: () => import("../views/work-sched/home/index.vue"),
    meta: { title: "Home", authRequired: true },
  },
  {
    path: "/work-sched/profile",
    name: "ws-profile",
    component: () => import("../views/work-sched/profile/index.vue"),
    meta: { title: "My Profile", authRequired: true },
  },
  {
    path: "/work-sched/user-manual",
    name: "ws-user-manual",
    component: () => import("../views/work-sched/user-manual/index.vue"),
    meta: { title: "User Manual", authRequired: true, role: ["admin", "hr-admin"] },
  },
  {
    path: "/work-sched/time-sheet",
    name: "ws-time-sheet",
    component: () => import("../views/work-sched/time-sheet/index.vue"),
    meta: { title: "My Time Sheet", authRequired: true },
  },
  {
    path: "/work-sched/dtr",
    name: "ws-dtr",
    component: () => import("../views/work-sched/dtr/index.vue"),
    meta: { title: "My Daily Time Records", authRequired: true },
  },
  {
    path: "/work-sched/loan-ledger",
    name: "ws-loan-ledger",
    component: () => import("../views/work-sched/loan-ledger/index.vue"),
    meta: { title: "My Loan Ledger", authRequired: true },
  },
  {
    path: "/work-sched/leave-ledger",
    name: "ws-leave-ledger",
    component: () => import("../views/work-sched/leave-ledger/index.vue"),
    meta: { title: "My Leave Ledger", authRequired: true },
  },
  {
    path: "/work-sched/payslip",
    name: "ws-payslip",
    component: () => import("../views/work-sched/payslip/index.vue"),
    meta: { title: "My Payslip", authRequired: true },
  },
  {
    path: "/work-sched/performance",
    name: "ws-performance",
    component: () => import("../views/work-sched/performance/index.vue"),
    meta: { title: "Performance Evaluation", authRequired: true },
  },
  {
    path: "/work-sched/reports/dtr",
    name: "ws-reports-dtr",
    component: () => import("../views/work-sched/reports/dtr-report.vue"),
    meta: { title: "DTR Report", pageTitle: "Reports", authRequired: true },
  },
  {
    path: "/work-sched/reports/dtr-all",
    name: "ws-reports-dtr-all",
    component: () => import("../views/work-sched/reports/dtr-all-report.vue"),
    meta: { title: "DTR — All Employees", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/tardiness",
    name: "ws-reports-tardiness",
    component: () => import("../views/work-sched/reports/tardiness-report.vue"),
    meta: { title: "Tardiness & Lates", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/absences",
    name: "ws-reports-absences",
    component: () => import("../views/work-sched/reports/absences-report.vue"),
    meta: { title: "Absences", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/overtime",
    name: "ws-reports-overtime",
    component: () => import("../views/work-sched/reports/overtime-report.vue"),
    meta: { title: "Overtime Report", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/sss",
    name: "ws-reports-sss",
    component: () => import("../views/work-sched/reports/sss-report.vue"),
    meta: { title: "SSS Contribution", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/philhealth",
    name: "ws-reports-philhealth",
    component: () => import("../views/work-sched/reports/philhealth-report.vue"),
    meta: { title: "PhilHealth Contribution", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/pagibig",
    name: "ws-reports-pagibig",
    component: () => import("../views/work-sched/reports/pagibig-report.vue"),
    meta: { title: "Pag-IBIG Contribution", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/bir",
    name: "ws-reports-bir",
    component: () => import("../views/work-sched/reports/bir-tax-report.vue"),
    meta: { title: "BIR Tax Withholding", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/payroll-register",
    name: "ws-reports-payroll-register",
    component: () => import("../views/work-sched/reports/payroll-register.vue"),
    meta: { title: "Payroll Register", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/bank-credit",
    name: "ws-reports-bank-credit",
    component: () => import("../views/work-sched/reports/bank-credit.vue"),
    meta: { title: "Bank Credit Listing", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/denomination",
    name: "ws-reports-denomination",
    component: () => import("../views/work-sched/reports/denomination.vue"),
    meta: { title: "Denomination Register", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/thirteenth-month",
    name: "ws-reports-thirteenth-month",
    component: () => import("../views/work-sched/reports/thirteenth-month.vue"),
    meta: { title: "13th Month Register", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/allowances",
    name: "ws-reports-allowances",
    component: () => import("../views/work-sched/reports/allowances.vue"),
    meta: { title: "Allowances Report", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/loans",
    name: "ws-reports-loans",
    component: () => import("../views/work-sched/reports/loans.vue"),
    meta: { title: "Loans Report", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/balances",
    name: "ws-reports-balances",
    component: () => import("../views/work-sched/reports/balances.vue"),
    meta: { title: "Leave & Loan Balances", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/gov-deductions",
    name: "ws-reports-gov-deductions",
    component: () => import("../views/work-sched/reports/gov-deductions.vue"),
    meta: { title: "Government Deductions", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/attendance-count",
    name: "ws-reports-attendance-count",
    component: () => import("../views/work-sched/reports/attendance-count.vue"),
    meta: { title: "Count Attendance", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/work-sched/reports/perfect-attendance",
    name: "ws-reports-perfect-attendance",
    component: () => import("../views/work-sched/reports/perfect-attendance.vue"),
    meta: { title: "Perfect Attendance", pageTitle: "Reports", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/admin/statutory-forms",
    name: "admin-statutory-forms",
    component: () => import("../views/admin/statutory-forms/index.vue"),
    meta: { title: "Statutory Forms", pageTitle: "Administration", authRequired: true, permission: "view-reports" },
  },
  {
    path: "/admin/companies",
    name: "admin-companies",
    component: () => import("../views/admin/companies.vue"),
    meta: { title: "Companies", pageTitle: "Administration", authRequired: true, permission: "manage-compensation" },
  },
  {
    path: "/work-sched/transactions/time-logs",
    name: "ws-tx-time-logs",
    component: () => import("../views/work-sched/transactions/time-logs.vue"),
    meta: { title: "Time Logs", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/change-shifts",
    name: "ws-tx-change-shifts",
    component: () => import("../views/work-sched/transactions/change-shifts.vue"),
    meta: { title: "Change Shifts", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/change-day-types",
    name: "ws-tx-change-day-types",
    component: () => import("../views/work-sched/transactions/change-day-types.vue"),
    meta: { title: "Change Day Types", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/official-business",
    name: "ws-tx-official-business",
    component: () => import("../views/work-sched/transactions/official-business.vue"),
    meta: { title: "Official Business", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/leaves",
    name: "ws-tx-leaves",
    component: () => import("../views/work-sched/transactions/leaves.vue"),
    meta: { title: "Leaves", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/overtime",
    name: "ws-tx-overtime",
    component: () => import("../views/work-sched/transactions/overtime.vue"),
    meta: { title: "Overtime", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/undertime",
    name: "ws-tx-undertime",
    component: () => import("../views/work-sched/transactions/undertime.vue"),
    meta: { title: "Undertime", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/work-sched/transactions/my-requests",
    name: "ws-tx-my-requests",
    component: () => import("../views/work-sched/transactions/my-requests.vue"),
    meta: { title: "My Requests", pageTitle: "Transactions", authRequired: true },
  },
  {
    path: "/admin/pending-approvals",
    name: "ws-admin-pending-approvals",
    component: () => import("../views/admin/pending-approvals.vue"),
    meta: { title: "Pending Approvals", pageTitle: "Administration", authRequired: true, permission: "approve-requests" },
  },
  {
    path: "/admin/users",
    name: "ws-admin-users",
    component: () => import("../views/admin/users.vue"),
    meta: { title: "Users", pageTitle: "Administration", authRequired: true, permission: "manage-users" },
  },
  {
    path: "/admin/roles",
    name: "ws-admin-roles",
    component: () => import("../views/admin/roles.vue"),
    meta: { title: "Roles", pageTitle: "Administration", authRequired: true, permission: "manage-roles" },
  },
  {
    path: "/admin/permissions",
    name: "ws-admin-permissions",
    component: () => import("../views/admin/permissions.vue"),
    meta: { title: "Permissions", pageTitle: "Administration", authRequired: true, permission: "manage-permissions" },
  },
  {
    path: "/admin/employees",
    name: "ws-admin-employees",
    component: () => import("../views/admin/employees.vue"),
    meta: { title: "Employees", pageTitle: "Administration", authRequired: true, permission: "manage-employees" },
  },
  {
    path: "/admin/employees/:id",
    name: "ws-admin-employee-detail",
    component: () => import("../views/admin/employee-detail.vue"),
    meta: { title: "Employee Profile", pageTitle: "Administration", authRequired: true, permission: "manage-employees" },
  },
  {
    path: "/admin/menus",
    name: "ws-admin-menus",
    component: () => import("../views/admin/menus.vue"),
    meta: { title: "Menu Builder", pageTitle: "Administration", authRequired: true, permission: "manage-menus" },
  },
  {
    path: "/admin/audit-logs",
    name: "ws-admin-audit-logs",
    component: () => import("../views/admin/audit-logs.vue"),
    meta: { title: "Audit Logs", pageTitle: "Administration", authRequired: true, permission: "view-audit-logs" },
  },
  {
    path: "/admin/dtr-upload",
    name: "ws-admin-dtr-upload",
    component: () => import("../views/admin/dtr-upload.vue"),
    meta: { title: "Upload DTR", pageTitle: "Administration", authRequired: true, permission: "manage-upload-dtr" },
  },
  {
    path: "/admin/dtr-list",
    name: "ws-admin-dtr-list",
    component: () => import("../views/admin/dtr-list.vue"),
    meta: { title: "DTR Records", pageTitle: "Administration", authRequired: true, permission: "manage-upload-dtr" },
  },
  {
    path: "/admin/biometric-upload",
    name: "ws-admin-biometric-upload",
    component: () => import("../views/admin/biometric-upload.vue"),
    meta: { title: "Biometric Upload", pageTitle: "Administration", authRequired: true, permission: "manage-upload-dtr" },
  },
  {
    path: "/admin/leave-balance-upload",
    name: "ws-admin-leave-balance-upload",
    component: () => import("../views/admin/leave-balance-upload.vue"),
    meta: { title: "Upload Leave Balances", pageTitle: "Administration", authRequired: true, permission: "manage-employees" },
  },
  {
    path: "/admin/time-sheets",
    name: "ws-admin-time-sheets",
    component: () => import("../views/admin/time-sheets.vue"),
    meta: { title: "Employee Time-Sheets", pageTitle: "Administration", authRequired: true, permission: "manage-employee-timesheet" },
  },
  {
    path: "/admin/shift-schedules",
    name: "ws-admin-shift-schedules",
    component: () => import("../views/admin/shift-schedules.vue"),
    meta: { title: "Shift Schedules", pageTitle: "Maintenance", authRequired: true, permission: "manage-shift-schedules" },
  },
  {
    path: "/admin/holidays",
    name: "ws-admin-holidays",
    component: () => import("../views/admin/holidays.vue"),
    meta: { title: "Holidays", pageTitle: "Maintenance", authRequired: true, permission: "manage-holidays" },
  },
  {
    path: "/admin/leave-types",
    name: "ws-admin-leave-types",
    component: () => import("../views/admin/leave-types.vue"),
    meta: { title: "Leave Types", pageTitle: "Maintenance", authRequired: true, permission: "manage-leave-types" },
  },
  {
    path: "/admin/branches",
    name: "ws-admin-branches",
    component: () => import("../views/admin/branches.vue"),
    meta: { title: "Branches", pageTitle: "Maintenance", authRequired: true, permission: "manage-org-structure" },
  },
  {
    path: "/admin/departments",
    name: "ws-admin-departments",
    component: () => import("../views/admin/departments.vue"),
    meta: { title: "Departments", pageTitle: "Maintenance", authRequired: true, permission: "manage-org-structure" },
  },
  {
    path: "/admin/divisions",
    name: "ws-admin-divisions",
    component: () => import("../views/admin/divisions.vue"),
    meta: { title: "Divisions", pageTitle: "Maintenance", authRequired: true, permission: "manage-org-structure" },
  },
  {
    path: "/admin/positions",
    name: "ws-admin-positions",
    component: () => import("../views/admin/positions.vue"),
    meta: { title: "Positions", pageTitle: "Maintenance", authRequired: true, permission: "manage-org-structure" },
  },
  {
    path: "/admin/customers",
    name: "ws-admin-customers",
    component: () => import("../views/admin/customers.vue"),
    meta: { title: "Customers", pageTitle: "Maintenance", authRequired: true, permission: "manage-org-structure" },
  },
  {
    path: "/admin/user-manual",
    name: "ws-admin-user-manual",
    component: () => import("../views/admin/user-manual.vue"),
    meta: { title: "User Manual", pageTitle: "Administration", authRequired: true, permission: "manage-user-manual" },
  },
  {
    path: "/admin/announcements",
    name: "ws-admin-announcements",
    component: () => import("../views/admin/announcements.vue"),
    meta: { title: "Announcements", pageTitle: "Maintenance", authRequired: true, permission: "manage-announcements" },
  },
  {
    path: "/admin/allowances",
    name: "ws-admin-allowances",
    component: () => import("../views/admin/allowances.vue"),
    meta: { title: "Allowances", pageTitle: "Maintenance", authRequired: true, permission: "manage-compensation" },
  },
  {
    path: "/admin/compensation-settings",
    name: "ws-admin-compensation-settings",
    component: () => import("../views/admin/compensation-settings.vue"),
    meta: { title: "Compensation Settings", pageTitle: "Maintenance", authRequired: true, permission: "manage-compensation" },
  },
  {
    path: "/admin/compensation-settings-list",
    name: "ws-admin-compensation-settings-list",
    component: () => import("../views/admin/compensation-settings-list.vue"),
    meta: { title: "Compensation by Company", pageTitle: "Maintenance", authRequired: true, permission: "manage-compensation" },
  },
  {
    path: "/admin/contribution-tables",
    name: "ws-admin-contribution-tables",
    component: () => import("../views/admin/contribution-tables.vue"),
    meta: { title: "Contribution Tables", pageTitle: "Maintenance", authRequired: true, permission: "manage-contribution-tables" },
  },
  {
    path: "/admin/loans",
    name: "ws-admin-loans",
    component: () => import("../views/admin/loans.vue"),
    meta: { title: "Loans", pageTitle: "Payroll", authRequired: true, permission: "manage-loans" },
  },
  {
    path: "/admin/payroll-groups",
    name: "ws-admin-payroll-groups",
    component: () => import("../views/admin/payroll-groups.vue"),
    meta: { title: "Payroll Groups", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/payroll-runs",
    name: "ws-admin-payroll-runs",
    component: () => import("../views/admin/payroll-runs.vue"),
    meta: { title: "Payroll Runs", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/deduction-maintenance",
    name: "ws-admin-deduction-maintenance",
    component: () => import("../views/admin/deduction-maintenance.vue"),
    meta: { title: "Deduction Maintenance", pageTitle: "Payroll", authRequired: true, permission: "manage-deduction-exemptions" },
  },
  {
    path: "/admin/payroll-calculator",
    name: "ws-admin-payroll-calculator",
    component: () => import("../views/admin/payroll-calculator.vue"),
    meta: { title: "Payroll Calculator", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/payroll-master-report",
    name: "ws-admin-payroll-master-report",
    component: () => import("../views/admin/payroll-master-report.vue"),
    meta: { title: "Payroll Master Report", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/payroll-master-report-detailed",
    name: "ws-admin-payroll-master-report-detailed",
    component: () => import("../views/admin/payroll-master-report-detailed.vue"),
    meta: { title: "Payroll Master Report (Detailed)", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/payroll-runs/:id",
    name: "ws-admin-payroll-run-detail",
    component: () => import("../views/admin/payroll-run-detail.vue"),
    meta: { title: "Payroll Run", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/admin/payslips/:id",
    name: "ws-admin-payslip-detail",
    component: () => import("../views/admin/payslip-detail.vue"),
    meta: { title: "Payslip", pageTitle: "Payroll", authRequired: true, permission: "manage-payroll" },
  },
  {
    path: "/work-sched/calendar",
    name: "ws-calendar",
    component: () => import("../views/work-sched/calendar/index.vue"),
    meta: { title: "Calendar", authRequired: true },
  },
  {
    path: "/work-sched/directory",
    name: "ws-directory",
    component: () => import("../views/work-sched/directory/index.vue"),
    meta: { title: "Company Directory", authRequired: true, permission: "view-directory" },
  },
  {
    path: "/work-sched/my-team",
    name: "ws-my-team",
    component: () => import("../views/work-sched/my-team/index.vue"),
    meta: { title: "My Team", authRequired: true, permission: "approve-requests" },
  },
  {
    path: "/work-sched/excess-hours",
    name: "ws-excess-hours",
    component: () => import("../views/work-sched/excess-hours/index.vue"),
    meta: { title: "My Excess Hours", authRequired: true },
  },
  {
    path: "/work-sched/analytics",
    name: "ws-analytics",
    component: () => import("../views/work-sched/analytics/index.vue"),
    meta: { title: "Analytics", authRequired: true },
  },

  {
    path: "/pages/faqs",
    name: "faqs",
    component: () => import("../views/pages/faqs.vue"),
    meta: { title: "FAQs", pageTitle: "Pages", authRequired: true },
  },
  {
    path: "/pages/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/pages/privacy-policy.vue"),
    meta: { title: "Privacy Policy", pageTitle: "Pages" },
  },
  {
    path: "/pages/term-conditions",
    name: "term-conditions",
    component: () => import("../views/pages/term-conditions.vue"),
    meta: { title: "Terms & Conditions", pageTitle: "Pages" },
  },
  {
    path: "/pages/maintenance",
    name: "maintenance",
    component: () => import("../views/pages/maintenance.vue"),
    meta: { title: "Maintenance" },
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    component: () => import("../views/pages/coming-soon.vue"),
    meta: { title: "Coming Soon" },
  },

  {
    path: "/403",
    name: "error-403",
    component: () => import("../views/auth/errors/403.vue"),
    meta: { title: "Forbidden" },
  },
  {
    path: "/500",
    name: "error-500",
    component: () => import("../views/auth/errors/500.vue"),
    meta: { title: "Server Error" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/auth/errors/404.vue"),
    meta: { title: "Page Not Found" },
  },
];
